import { computed, onMounted } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { getDashboardResumenAction } from "../actions";
export function useDashboardQuery() {
  const query = useQuery({
    queryKey: [ "dashboard"],
    queryFn: () => getDashboardResumenAction(),
    staleTime: 60 * 1000,
    refetchInterval: 30000,
    placeholderData: (previousData) => previousData
  });

  const dashboardData = computed(() => query.data.value?.data);

  return {
    dashboardData,
    ...query,
  };
}
